import { NodeProps, NodeTypes } from "reactflow";

import EventNode from "./EventNode";
import {
    DataEnricherApiNode,
    DataEnricherDbLookupNode,
    DataEnricherGraphLookupNode,
    DataEnricherMlPredictionNode,
    EvaluatorNode,
    NotificationEmailNode,
    NotificationSlackNode,
    PushDbNode,
    PushQueueNode,
    PushWebhookNode,
    TransformerNode,
} from "./Nodes";
import PlaceholderNode from "./PlaceholderNode";
import RequestNode from "./RequestNode";


export const nodeTypes: NodeTypes = {
    eventNode: EventNode,
    requestNode: RequestNode,
    placeholder: PlaceholderNode,
    evaluatorNode: EvaluatorNode as React.FC<NodeProps>,
    transformerNode: TransformerNode as React.FC<NodeProps>,
    dataEnricherApiNode: DataEnricherApiNode as React.FC<NodeProps>,
    dataEnricherDbLookupNode: DataEnricherDbLookupNode as React.FC<NodeProps>,
    dataEnricherGraphLookupNode: DataEnricherGraphLookupNode as React.FC<NodeProps>,
    dataEnricherMlPredictionNode: DataEnricherMlPredictionNode as React.FC<NodeProps>,
    pushWebhookNode: PushWebhookNode as React.FC<NodeProps>,
    pushDbNode: PushDbNode as React.FC<NodeProps>,
    pushQueueNode: PushQueueNode as React.FC<NodeProps>,
    notificationEmailNode: NotificationEmailNode as React.FC<NodeProps>,
    notificationSlackNode: NotificationSlackNode as React.FC<NodeProps>,
};
